import React from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useFetchGoogleFreeBookingLinksSettings } from "../api";
import { FormGoogleFreeBookingLinksIslandSettings } from "./settings";

type Props = {
	hotelID: string;
};

export const GoogleFreeBookingLinksSettings: React.FC<Props> = ({ hotelID }) => {
	const { data } = useFetchGoogleFreeBookingLinksSettings({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <FormGoogleFreeBookingLinksIslandSettings googleFreeBookingLinksSettingsQueryData={data} />;
};
